import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {ConfigModel} from './config.model';
import {Store} from '@ngxs/store';
import {SetConfig} from '../../../state/actions/appState.actions';
import {mergeMap, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private httpClient: HttpClient;

  constructor(
    private handler: HttpBackend,
    private store: Store
  ) {
    this.httpClient = new HttpClient(handler);
  }

  getConfig() {
    return this.httpClient.get<ConfigModel>(`/assets/config.json?v=${new Date().getTime()}`)
      .pipe(
        mergeMap(
          (config: ConfigModel) => this.store.dispatch(new SetConfig(config))
        )
      );
  }
}
